import axios from "axios";
import axiosUtil from "@plannel/utils/axios-bigint";
import authService from "./auth-service";

const generateQTP = (tenant, username) => {
  return axios.post("/system/otp", username, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse,
    transformRequest: axiosUtil.transformRequest
  });
}

const resetPassword = (params) => {
  return axios.post("/system/password-reset", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(params.tenant)
    },
    transformResponse: axiosUtil.transformResponse,
    transformRequest: axiosUtil.transformRequest
  });
}

const verifyCode = (tenant, params) => {
  return axios.post("/system/verify-code", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
}

const verifyPasswordResetToken = (params) => {
  const tenant = params.tenant;
  return axios.post("/system/verify-password-reset-token", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
}

const verifySignupToken = (params) => {
  return axios.post("/system/verify-signup-token", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(params.tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
};

const getDefaultLoginPolicies = () => {
  return axios.get("/system/login-policies", {
    headers: {
      "Content-type": "application/json"
    },
    transformResponse: axiosUtil.transformResponse
  });
}

const getPasswordPolicies = () => {
  return axios.get("/system/password-policies", {
    headers: {
      "Content-type": "application/json"
    },
    transformResponse: axiosUtil.transformResponse
  });
}

const changePassword = (tenant, params) => {
  return axios.post("/system/password", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
}

const verifyPassword = params => {
  return axios.get("/system/verify-password", {
    params: {
      "password": params
    }
  });
}

const verifyMailAuthentication = (params) => { 
  return axios.post("/system/verify-mail-authentication", params, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(params.tenant)
    },
    transformResponse: axiosUtil.transformResponse,
    transformRequest: axiosUtil.transformRequest
  });
}

const verifyTenant = async (tenant) => {
  const params = {tenantId: authService.getTenant(tenant)}
  const result = await axios.get("/system/verify-tenant", {params}, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant("public")
    }
  });
  return result;
}

const systemService = {
  generateQTP,
  resetPassword,
  verifyCode,
  verifyPasswordResetToken,
  verifySignupToken,
  getDefaultLoginPolicies,
  getPasswordPolicies,
  changePassword,
  verifyPassword,
  verifyMailAuthentication,
  verifyTenant
}

export default systemService;